import { message, Modal } from 'antd';
/**
 * 华视身份证阅读器接口
 * @param {*} type 阅读器类型（xzx：新中新  hs：华视）
 * @param {*} readPort 阅读器接口端口
 * @param {*} mode 读取模式（手动/自动）
 * @param {*} callback 回调的函数
 */
export const readByHs = (readPort, mode, callback) => {
    // debugger;
    if(!readPort || typeof (readPort) == "undefined"){
        readPort = '19196';
    }
    if(mode == 'auto' ){
        message.warn('该身份证阅读器暂不支持自动读卡！')
    } else if(mode == 'manual') {
        fetch(`http://127.0.0.1:${readPort}/OpenDevice`).then(response => response.json())
        .then((data) => {
            if(data) {
                if(data.resultFlag === -3){
                    message.warn(data.errorMsg);
                }else {
                    fetch(`http://127.0.0.1:${readPort}/readcard`).then(response => response.json())
                    .then((data) => {
                        if (data) {
                            if(data.resultFlag !== 0) {
                                message.warn(data.errorMsg)
                            } else {
                                callback(data.certNumber);
                            }
                        } else {
                            message.warn('没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确');
                        }
                    }).catch(e => Modal.error({ title: '错误信息', content: '没有找到读卡器！1、请检查设备与计算机连接是否正常。2.请检查机具驱动安装是否正确' }))
                }
            }
        })
        
    }
  }


// WEBPACK FOOTER //
// ./components/yxxc/readCard/readByHs.js